import { render, staticRenderFns } from "./cassso.vue?vue&type=template&id=0570b338&scoped=true&"
import script from "./cassso.vue?vue&type=script&lang=js&"
export * from "./cassso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0570b338",
  null
  
)

export default component.exports